export default __webpack_public_path__ + "static/media/2.c3a0e1a4.jpg";